<!--设备台账-->
<template>
	<div class="archivesBody">
		<elArchivesDeviceTree :dataList="archivesGroupTree" @checkItem="nowGroup = $event" />
		<!--右边-->
		<div class="archiverRigth">
			<div class="dataAreaTop">
				<div class="archiverTableOperating">
					<div style="width: 20%;">
						<el-input v-model="search" size="medium" placeholder="输入关键字搜索" />
					</div>
					<el-button type="primary" plain size='small' @click="addShow=true" style='margin-left: 10px;'>添加</el-button>
					<el-button type="danger" plain size='small' @click="batchDeletion()" :style="margigStyle" style='margin-left: 10px;'>批量删除</el-button>
					<el-button type="primary" size='small' v-if="archivesList.length > 0" @click="getQRCodeAppEquipInfo" style='margin-right: 20px;'>导出设备二维码</el-button>
				</div>
			</div>
			<div class="dataAreaBottom">
				<el-table :data="archivesList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))" border style="width: 100%" @selection-change="handleSelectionChange" @cell-mouse-enter="selectColumn">
					<el-table-column type="index" width="50">
					</el-table-column>
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column label="名称" prop="name">
					</el-table-column>
					<el-table-column label="类型" prop="typeName">
					</el-table-column>
					<el-table-column label="关联设备" prop="virtualDeviceName">
					</el-table-column>
					<el-table-column label="创建时间" prop="createTime" :formatter="formatTime">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width='300'>
						<template slot-scope="scope">
							<el-button type="primary" size='mini' @click='editColumn(scope.row)'>编辑</el-button>
							<el-button type="danger" size='mini' @click='deleteColumn(scope.row)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="width: 100%;display: flex;align-items: center;justify-content: flex-end;height: 5%;">
					<el-pagination background layout="prev, pager, next" :total="total" @current-change='clickChange' @prev-click="prevClick" @next-click="nextClick">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--添加台账弹窗-->
		<el-dialog title="添加台账" :visible.sync="addShow">
			<el-dialog width="40%" title="添加台账" :visible.sync="addContentFormShow" append-to-body>
				<!--设备树-->
				<div style="display: flex;">
					<div class="device-tree">
						<elRadioTree :dataList='virtualDeviceList' @checkItem="deviceCheckItem"></elRadioTree>
					</div>
					<el-form :model="form" ref="form" style="border: 1px solid #ded7d7;width: 80%;height: 550px;margin-left: 250px;overflow: auto;">
						<el-form-item label="台账名称" prop="name" label-width="120px" :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]" style="margin-top: 10px;">
							<el-input v-model="form.name" autocomplete="off" style="width: 90%;"></el-input>
						</el-form-item>
						<el-form-item label="绑定设备" label-width="120px">
							<el-input v-model="form.deviceName" placeholder="请选择设备" :disabled="true" style="width: 90%;"></el-input>
						</el-form-item>
						<el-form-item :label="item.propertyName" label-width="120px" v-for="item in propertyList.property">
							<el-input v-model="form[item.typePropertyCode]" autocomplete="off" style="width:90% ;"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="addContentFormShow = false">取 消</el-button>
					<el-button type="primary" @click="determine()">确 定</el-button>
				</div>
			</el-dialog>
			<div class="addDialog-body">
				<el-tabs  v-model="firstLevel" @tab-click="handleClick">
					<el-tab-pane :label="item.typeName" v-if="getEntityTypeList!=null && getEntityTypeList.length>0" :name="item.typeCode" v-for="item in getEntityTypeList">
						<!--内容-->
						<div class="itemContent">
							<el-table :data="firstLevelList" stripe style="width: 100%" height="250">
								<el-table-column prop="name" label="台账名称" width="180">
								</el-table-column>
								<el-table-column prop="virtualDeviceName" label="绑定的设备" width="180">
								</el-table-column>
								<el-table-column prop="createTime" label="创建时间" :formatter="formatTime">
								</el-table-column>
							</el-table>
						</div>
						<div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 10px;">
							<el-button type="primary" size="mini" @click="addArchives(item)">添加</el-button>
						</div>
						<!--第二级-->
						<el-tabs v-model="secondLevel" @tab-click="soconHandleClick" v-if="item.next.length!=0">
							<el-tab-pane :label="item2.typeName" :name="item2.typeCode" v-for="item2 in item.next">
								<!--内容-->
								<div class="itemContent">
									<el-table :data="firstLevelList" stripe style="width: 100%" height="250">
										<el-table-column prop="name" label="台账名称" width="180">
										</el-table-column>
										<el-table-column prop="virtualDeviceName" label="绑定的设备" width="180">
										</el-table-column>
										<el-table-column prop="createTime" label="创建时间" :formatter="formatTime">
										</el-table-column>
									</el-table>
								</div>
								<div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 10px;">
									<el-button type="primary" size="mini" @click="addArchives(item2)">添加</el-button>
								</div>
								<!--第三级-->
								<el-tabs v-model="thirdLevel" @tab-click="thirdHandleClick" v-if="item2.next!=null">
									<el-tab-pane :label="item3.typeName" :name="item3.typeCode" v-for="item3 in item2.next">
										<!--内容-->
										<div class="itemContent">
											<el-table :data="thirdLevelList" stripe style="width: 100%" height="250">
												<el-table-column prop="name" label="台账名称" width="180">
												</el-table-column>
												<el-table-column prop="virtualDeviceName" label="绑定的设备" width="180">
												</el-table-column>
												<el-table-column prop="createTime" label="创建时间" :formatter="formatTime">
												</el-table-column>
											</el-table>
										</div>
										<div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 10px;">
											<el-button type="primary" size="mini" @click="addArchives(item3)">添加</el-button>
										</div>
										<!--第四级-->
										<el-tabs v-model="fourthLevel" @tab-click="" v-if="item3.next!=null">
											<el-tab-pane :label="item4.typeName" :name="item4.typeCode" v-for="item4 in item3.next">

											</el-tab-pane>
										</el-tabs>
									</el-tab-pane>
								</el-tabs>
							</el-tab-pane>
						</el-tabs>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-dialog>
		<!--编辑弹窗-->
		<el-dialog width="40%" title="编辑台账" :visible.sync="editShow" append-to-body>
			<div style="display: flex;">
				<div class="device-tree">
					<elRadioTree :dataList='virtualDeviceList' @checkItem="deviceCheckItem"></elRadioTree>
				</div>
				<el-form :model="editFrom" ref="editFrom" style="border: 1px solid #ded7d7;width: 80%;height: 550px;margin-left: 250px;">
					<el-scrollbar style="height:98%;width: 100%;">
						<el-form-item label="台账名称" prop="name" label-width="135px" :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]" style="margin-top: 10px;">
							<el-input v-model="editFrom.name" autocomplete="off" style="width: 90%;"></el-input>
						</el-form-item>
						<el-form-item label="绑定设备" label-width="135px">
							<el-input v-model="editFrom.deviceName" placeholder="请选择设备" :disabled="true" style="width: 90%;"></el-input>
						</el-form-item>
						<el-form-item :label="item.propertyName" label-width="135px" v-for="item in editData.property">
							<el-input v-model="editFrom[item.typePropertyCode]" @input="change($event)"  style="width:90% ;"></el-input>
						</el-form-item>
					</el-scrollbar>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editShow = false">取 消</el-button>
				<el-button type="primary" @click="editConfirm()">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	import elArchivesDeviceTree from '@/components/module/tree/elArchivesDeviceTree.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			elArchivesDeviceTree,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				nowGroup: undefined,
				search: '', //过滤
				archivesList: [], //台账列表
				pageIndex: 1,
				size: 10,
				total: 0,
				formLabelWidth: '120px',
				addShow: false,
				firstLevel: '', //选中第一级的数据
				firstLevelList: [],
				secondLevel: '', //第二级的数据
				secondLevelList: [],
				thirdLevel: '', //第三级的数据
				thirdLevelList: [],
				fourthLevel: '', //第四级的数据
				addContentFormShow: false,
				propertyList: [], //选中的台账信息
				form: {
					name: '',
					deviceName: '',
				},
				selectDevice: {},
				selectItemList: [], //选中多个
				editShow: false,
				editFrom: {
					name: '',
					deviceName: '',
					deviceNo: '',
				},
				editData: {}, //选中的数据
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.initData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			margigStyle(){
				if(this.archivesList.length <= 0){
				   return {'margin-right':'20px'}	
				}
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			getEntityTypeList() {
				let list = this.$store.archivesStore.getters.getArchivesTypeList
				return isempty(list) ? [] : list
			},
			nowVirtualDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			nowUnitArchivesTree() {
				//当前单位可以查看的台账设备树
				if(isempty(this.nowUnit)) {
					return undefined
				}
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			archivesGroupTree() {
				if(this.nowUnitArchivesTree == undefined) {
					return []
				}
				//过滤掉设备
				let list = filterTreeRecursive([copy(this.nowUnitArchivesTree)], (item) => {
					return item.entityName == 'AppClassType'
				})
				if(!isempty(list)) {
					this.nowGroup = deviceList(list)[0]
					// console.log(this.nowGroup)
				}
				return deviceList(list)
			},
			nowArchivesTypeTree() {
				//要显示当前层级的数量
				var countMap = this.nowGroup == undefined ? {} : this.nowGroup.archivesCountMap
				var filterList = list => {
					var nList = []
					for(var i = 0, len = list.length; i < len; i++) {
						var item = list[i]
						if(item.entityName == 'MisEntityType') {
							item.typeName = item.typeName + '(' + (countMap.hasOwnProperty(item.typeCode) ?
								countMap[item.typeCode] : 0) + ')'
							nList.push(item)
						}
					}
					return nList
				}
				return filterList(copy(this.$store.archivesStore.getters.getArchivesTypeList))
			},
		},
		watch: {
			archivesGroupTree(nv, ov) {
				this.initData()
			},
			nowGroup(nv, ov) {
				this.initData()
			},
			nowVirtualDevice(nv, ov) {
				//选中设备后
				if(!isempty(nv)) {
					this.form.deviceName = nv.label
					this.editFrom.deviceName = nv.label
					this.editFrom.deviceNo = nv.no
				}
			},
			pageIndex(nv,ov){
				this.initData()
			}
			
		},
		methods: {
			initData() {
				//初始化数据
				if(isempty(this.archivesGroupTree)) {
					return
				}
				this.$api.archivesApi.getArchivesList(this.nowGroup.no, this.pageIndex, this.size, respon => {
					this.total = respon.total
					this.archivesList = respon.dataList
				})
			},
			getQRCodeAppEquipInfo(){
				if(isempty(this.nowGroup.no) && isempty(this.nowGroup.label)){
					return
				}
				this.$api.archivesApi.getQRCodeAppEquipInfo(this.nowGroup.no,this.nowGroup.label, respon => {
					saveAs(DWSystemSetting.downloadUrl + '/' + respon, this.nowGroup.label + "-设备信息.xls")
				})
			},
			change(e){
				this.$forceUpdate()
			},
			addArchives(item) {
				//添加台账
				this.propertyList = item
				this.$api.entityApi.getTypePropertyList(item.typeCode, respon => {
					this.propertyList.property = respon
					this.addContentFormShow = true
				})
			},
			handleClick() {
				//选中第一级
				//debugger
				this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.firstLevel,this.nowGroup.no, respon => {
					this.firstLevelList = respon
				})

			},
			soconHandleClick() {
				//选中第二级
				this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.secondLevel,this.nowGroup.no, respon => {
					this.secondLevelList = respon
				})
			},
			thirdHandleClick() {
				//选中第三级
				this.$api.archivesApi.getArchivesListByTypeCodeAndGroupNo(this.thirdLevel,this.nowGroup.no, respon => {
					this.thirdLevelList = respon
				})
			},
			deviceCheckItem(value) {
				this.form.deviceName = value.label
				this.form.deviceNo = value.no
			},
			determine() {
				//确认添加
				this.$refs.form.validate((valid) => {
					if (valid) {
						let archivesInfo = {
							"id": "",
							"name": this.form.name,
							"typeCode": this.propertyList.typeCode,
							"groupId": this.nowGroup.no,
							"unitid": this.nowGroup.unitid,
							"property": [],
							"next": [],
							"deviceNo": this.nowVirtualDevice.no
						}
						//定义台账属性值添加进去
						this.propertyList.property.forEach(item => {
							let obj = {
								"propertyCode": item.typePropertyCode,
								"value": this.form[item.typePropertyCode]
							}
							archivesInfo.property.push(obj)
						})
						//debugger
						this.$api.archivesApi.saveArchivesInfo(JSON.stringify(archivesInfo),
						respon => {
							if(!isempty(respon)) {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.form.name = ''
								this.initData()
								this.addContentFormShow = false
							}
						},err=>{
							this.$message({
								type: 'error',
								message: err
							});
						})
					}else{
						return false
					}
				})
			},
			editConfirm() {
				//确认编辑
				this.$refs.editFrom.validate((valid) => {
					if (valid) {
						let archivesInfo = {
							"id":this.editData.id,
							"name": this.editFrom.name,
							"typeCode": this.editData.typeCode,
							"groupId": this.editData.groupId,
							"property": [],
							"next": [],
							"deviceNo": this.editFrom.deviceNo
						}
						this.editData.property.forEach(item => {
							let obj = {
								"propertyCode": item.typePropertyCode,
								"value": this.editFrom[item.typePropertyCode]
							}
							archivesInfo.property.push(obj)
						})
						this.$api.archivesApi.saveArchivesInfo(JSON.stringify(archivesInfo), 
						respon => {
							if(!isempty(respon)) {
								this.$message({
									message: '保存成功',
									type: 'success'
								});
								this.initData()
								this.editShow = false
							}
						},err=>{
							this.$message({
								type: 'error',
								message: err
							});
						})
					}else{
						return false
					}
				})
			},
			handleSelectionChange(val) {
				this.selectItemList = val
			},
			editColumn(item) {
				//编辑台账付初始值
				this.editFrom.name = item.name
				this.editFrom.deviceName = item.virtualDeviceName
				this.editFrom.deviceNo = item.virtualDeviceNo
				this.$api.archivesApi.getPropertyValueTree(item.id, respon => {
					this.editData = respon
					if(!isempty(respon.property)) {
						respon.property.forEach(item => {
							this.editFrom[item.typePropertyCode] = item.value
						})
					}
					this.editShow = true
				})
			},
			selectColumn() {},
			batchDeletion() {
				//批量删除
				if(isempty(this.selectItemList)) {
					this.$message({
						message: '请选中数据',
						type: 'warning'
					});
					return
				}
				let pkids = ''
				this.selectItemList.forEach((item, index) => {
					if(index + 1 == this.selectItemList.length) {
						pkids += item.id
					} else {
						pkids += item.id + ','
					}
				})
				this.$alert('', '确定删除选中的数据吗？', {
					confirmButtonText: '确定',
					callback: action => {
						this.$api.archivesApi.deleteArchives(pkids, respon => {
							if(!isempty(respon)) {
								this.initData()
								this.$message({
									message: '删除成功',
									type: 'success'
								});
							}
						})
					}
				});
			},
			deleteColumn(data) {
				//单个删除
				this.$confirm('确定删除此项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.archivesApi.deleteArchives(data.id, respon => {
						if(!isempty(respon)) {
							this.initData()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			prevClick() {
				//上一页
				if(this.pageIndex == 1) {
					this.$message('当前为第一页');
					return
				}
				this.pageIndex -= 1
			},
			clickChange(index) {
				this.pageIndex = index
				//点击页数
			},
			nextClick() {
				if(this.pageIndex == Math.ceil(this.total / this.size)) {
					this.$message('当前为最后一页');
					return
				}
				this.pageIndex += 1
			},
			formatTime(row, column, cellValue) {
				return new Date(row.createTime).format('yyyy-MM-dd')
			},
		}
	}
</script>
<style>
	.archivesBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
	
	.archiverRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.dataAreaTop {
		width: 100%;
		display: flex;
		align-items: center;
		height: 6%;
	}
	
	.dataAreaBottom {
		width: 98%;
		margin: 0 auto;
		height: 90%;
	}
	
	.archiverTableOperating {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.itemContent {
		width: 100%;
		min-height: 50px;
	}
	
	.device-tree {
		height: 550px;
		overflow: hidden;
		position: absolute;
		z-index: 999;
		border-bottom: 1px solid #ded7d7;
	}
	
	.el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden;
	}
</style>